import RemindersPage from './components/RemindersPage';

export default RemindersPage;
